const tr = new PIXI.Rectangle();
const tm = [
    new PIXI.Matrix(),
    new PIXI.Matrix(),
];

export function changeParent(child: PIXI.Container, parent: PIXI.Container): void {
    if (child.parent !== parent && parent) {
        if (!child.parent) {
            parent.addChild(child);
        } else {
            // updateTransform is not enough, this call updates worldTransform properly
            child.getBounds(false, tr);
            parent.getBounds(false, tr);
            let thisMatrix = tm[0];
            const parentMatrix = tm[1];
            child.worldTransform.copyTo(thisMatrix);
            parent.worldTransform.copyTo(parentMatrix);
            thisMatrix = thisMatrix.prepend(parentMatrix.invert());
            thisMatrix.decompose(child.transform);
            parent.addChild(child);
        }
    }
}